import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  PageTheme,
} from '@backstage/theme';

// Komax corporate identity, taken from the "Komax Products" PowerPoint master
// (ch10/plant-data-management → .claude/skills/presentation).
export const komaxColors = {
  blue: '#396999', // accent1 — primary
  blueDark: '#295077', // end of the corporate gradient
  blueDeep: '#1d3a57', // navigation in dark mode
  blueMid: '#8BA8CB', // accent2
  blueLight: '#C5D5EB', // accent3
  red: '#F04C54', // accent4 — signal colour, use sparingly
  grey: '#767A7C', // lt2
  greyLight: '#C6CACD', // dk2
  background: '#F1F2F3', // master background
};

const fontFamily = 'Arial, Helvetica, sans-serif';

// Every page header uses the corporate gradient without Backstage's "burst"
// shapes, like the coloured slides in the corporate deck.
const komaxPage = genPageTheme({
  colors: [komaxColors.blue, komaxColors.blueDark],
  shape: 'none',
});

const pageTheme: Record<string, PageTheme> = Object.fromEntries(
  [
    'home',
    'documentation',
    'tool',
    'service',
    'website',
    'library',
    'other',
    'app',
    'apis',
    'card',
  ].map(id => [id, komaxPage]),
);

export const komaxLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: komaxColors.blue },
    secondary: { main: komaxColors.blueDark },
    error: { main: komaxColors.red },
    background: { default: komaxColors.background, paper: '#FFFFFF' },
    link: komaxColors.blue,
    linkHover: komaxColors.blueDark,
    navigation: {
      background: komaxColors.blueDark,
      indicator: komaxColors.red,
      color: '#d5e0ee',
      selectedColor: '#FFFFFF',
      navItem: { hoverBackground: komaxColors.blue },
      submenu: { background: komaxColors.blue },
    },
    tabbar: { indicator: komaxColors.red },
  },
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
});

export const komaxDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: komaxColors.blueMid },
    secondary: { main: komaxColors.blueLight },
    error: { main: komaxColors.red },
    link: komaxColors.blueMid,
    linkHover: komaxColors.blueLight,
    navigation: {
      background: komaxColors.blueDeep,
      indicator: komaxColors.red,
      color: '#b8c8dc',
      selectedColor: '#FFFFFF',
      navItem: { hoverBackground: komaxColors.blueDark },
      submenu: { background: komaxColors.blueDark },
    },
    tabbar: { indicator: komaxColors.red },
  },
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
});
